import { Card } from '../../../../../components/atoms';
import InfoIcon from '../../../../../components/molecules/InfoIcon/InfoIcon';
import { Table } from '../../../../../components/organisms/Table/Table';
import TableStatus from '../../../../../components/templates/TableStatus/TableStatus';
import { devPortalTableComponents } from './molecules';

export const DevPortalLayout = ({
  headers,
  data,
  rowAction,
  grid,
  isLoading,
  isError,
  error,
  tableStatusProps,
  refreshAPIKey,
}) => {
  return (
    <Card
      title="Developer Portal"
      className="devportal"
      icon={
        !isLoading && !isError && data.length > 0 ? (
          <InfoIcon description={'Make sure to keep your API key private. All API keys are set to automatically expire in 1 year.'} />
        ) : (
          <></>
        )
      }
    >
      <TableStatus
        isLoading={isLoading}
        isError={isError}
        error={error}
        {...tableStatusProps}
        table={
          <Table
            headers={headers}
            data={data}
            rowAction={rowAction}
            components={devPortalTableComponents({ refreshAPIKey })}
            grid={grid}
            // refreshAPIKey={refreshAPIKey}
          />
        }
      />
    </Card>
  );
};
